import { useEffectOnce } from '@navi-toolbox/hooks';

/**
 * @description
 * @param productId
 */
export const useRRPageView = (productId: string, stockId: string) => {
  useEffectOnce(() => {
    // eslint-disable-next-line func-names
    (window.rrApiOnReady = window.rrApiOnReady || []).push(function () {
      try {
        if (window.rrApi) {
          window.rrApi.view(productId, { stockId });
        }
      } catch (e) {
        /* empty */
      }
    });
  });
};
